import { TdsTcsTypes } from "./tdsTcsManagementType";

export const initialState: TdsTcsTypes = {
  fetching: false,
  savingEntry: false,
  error: null,
  success: null,
  message: null,
  statusCode: null,
  tdsPayableList: [],
  tdsPayableTotalCount: null,
  tdsPayableTotalTds: null,
  tdsPayableFinancialYear: null,
  tdsPayableTotalTaxAmount: null,
  tdsReportFetching: false,
  tdsReportError: null,
  tdsReportMessage: null,
  tdsReportList: null,
  tdsReportDetails: null,
  approvingTdsReport: false,
  addingTdsReportComment: false,
  addCommentTdsReportMessage: null,
  signingOffTdsReport: false,
  tanNumberList: [],
};
